/**
 * `vendor_id` untuk situs VENDOR: literal `'current_user'`, bukan UUID.
 *
 * Konvensi BE project ini — endpoint sendiri yang menerjemahkannya ke vendor milik sesi. Pola yang
 * sama dipakai `VendorProfileService.getExpiringCreds()`.
 *
 * **Kenapa konstanta, bukan string yang ditulis di tiap pemanggil:** halaman "Perbarui Dokumen"
 * dirancang untuk dipakai ulang admin dalam mode telaah, dengan `vendorId` datang dari
 * `PROFILE_EDIT_CONTEXT` (PLAN-PROFILE-EDIT-REUSE.md D1/§4). Selama nilainya hanya muncul di sini,
 * peralihan itu menyentuh satu baris per pemanggil dan tidak ada yang tertinggal.
 */
export const CURRENT_USER_VENDOR_ID = 'current_user';
